/** IA opcional: estado (servidor tem a chave? escritório ligou?), análise de mensagem da caixa postal e rascunho de resposta. */
import { z } from 'zod';
import { DataISO, Id } from './comum.js';

export const IaEstado = z.object({ /** o servidor tem a chave da API configurada */ disponivel: z.boolean(), /** o administrador deste escritório ligou */ ativa: z.boolean() });
export type IaEstado = z.infer<typeof IaEstado>;
export const IaEstadoBody = z.object({ ativa: z.boolean() });
export const IaAnaliseMensagem = z.object({
  resumo: z.string(), gravidade: z.enum(['INFORMATIVA', 'ATENCAO', 'URGENTE']), prazo: DataISO.nullable(), prazoTexto: z.string().nullable(),
  acaoSugerida: z.string(), tituloTarefa: z.string(), analisadaEm: z.string(),
});
export type IaAnaliseMensagem = z.infer<typeof IaAnaliseMensagem>;
export const IaAnalisarBody = z.object({ refazer: z.boolean().optional() }).nullish();
export const IaRascunhoBody = z.object({ tarefaId: Id, instrucao: z.string().trim().max(500).nullable().optional() });
export const IaRascunho = z.object({ texto: z.string() });
